export const sidebarWidth = {
  base: "0px",
  sm: "20vw",
  md: "18vw",
  lg: "14vw",
  "2xl": "250px",
};

export const topBarHeight = {base: "80px", md: "55px"};
